export const FIELDS_DICTIONARY = {
  name: 'Наименование',
  description: 'Описание',
  slug: 'Служебное наименование',
  serviceId: 'Мера поддержки',
  deadlineDays: 'Крайний срок',
  params: 'Параметры',
  sectionFields: 'Поля секций',
  applicationStarts: 'Дата начала приёма заявления',
  applicationEnds: 'Дата окончания приёма заявления',
  isInternal: 'Внутренняя',
  requiredFields: 'Обязательные входные поля',
  token: 'Токен',
  nomadic: 'Вид отношение к кочевью',
};
